import { connect } from 'react-redux'

import withDidMountRequest from 'app/connectors/withDidMountRequest'
import {
  getNotificationsLoadedGetNotifications,
  getNotificationsUnreadCount,
} from 'store/entities/notifications/selectors'
import { notifications, notificationsMarkedRead } from 'store/entities/notifications/actions'
import Notifications from 'app/domains/routes/Notifications/Notifications'

const mapStateToProps = state => ({
  loaded: getNotificationsLoadedGetNotifications(state),
  unreadCount: getNotificationsUnreadCount(state),
})

const mapDispatchToProps = {
  onLoadNotifications: notifications.get.request,
  markNotificationsRead: notificationsMarkedRead.get.request,
}

const mergeProps = (
  { loaded, unreadCount, ...stateProps },
  { onLoadNotifications, markNotificationsRead, ...dispatchProps },
  ownProps
) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onRequest: () => {
    if (!loaded) {
      onLoadNotifications()
    }
    if (unreadCount) {
      markNotificationsRead()
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(withDidMountRequest(Notifications))
